<template>
  <div class="table-box">
    <div class="table_card" style="margin-top: 6px">
      <el-table
        size="middle"
        :header-cell-style="{ background: '#f8fafa' }"
        align="center"
        current-row-key
        highlight-current-row
        height="40"
      >
        <el-table-column align="center" label="机构名称"></el-table-column>
        <!-- <el-table-column
          align="center"
          label="状态"
          width="100px"
        ></el-table-column> -->
        <!-- <el-table-column
          align="center"
          label="创建时间"
          width="140px"
        ></el-table-column> -->
        <el-table-column
          align="center"
          label="操作"
          width="240px"
        ></el-table-column>
      </el-table>
      <div v-if="openPanel">
        <el-tree
          ref="treeRef"
          class="filter-tree"
          accordion
          :expand-on-click-node="false"
          :load="loadNode2"
          lazy
          :props="defaultProps"
          node-key="adcode"
          :render-content="renderContent"
        ></el-tree>
      </div>
    </div>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="500px"
      class="dialog_container"
      @close="dialogVisibleClone"
    >
      <div class="dialog_content">
        <el-form
          :model="formData"
          :rules="rules"
          ref="formDataRef"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item prop="addName" label="名称">
            <el-input v-model="formData.addName"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import mapbox from "./components/map"
import mapLoca from "./components/mapLoca"
import AMap from "AMap" // 引入高德地图
export default {
  name: "standardAddress",
  components: {
    mapbox,
    mapLoca,
  },
  data() {
    return {
      title: "编辑",
      dialogVisible: false,
      rules: {
        address: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      openPanel: true,
      // 树形控件的配置
      defaultProps: {
        children: "children",
        label: "label",
      },
      provinceList: [], //省列表
      cityList: [], //市列表
      streetList: [], //街道列表
      areaList: [], //区列表
      committeeList: [], //委员会
      communityList: [],
      formData: {
        id: undefined,
        addName: "",
        parentId: "",
        shengId: "",
        quIdId: "",
        quId: "",
        jiedaoId: "",
        communityName: "",
        shiId: "",
        latitude: "",
        longitude: "",
        areaDivision: "",
        communityType: "",
      },
      //地图显示
      myMap: null,
      marker: [],
      isMap: true,
      mapshow: false,
      lookdata: false,
      data5: [],
      dataTree: [],
      // admin: sessionStorage.getItem("admin"),
      mouseTool: null,
      isTree: true,
      treeRow: {},
      treeStyle: "",
      normalInfo: {},
      orgLevel: 0,
      openPanel: true,
      defaultProps: {
        children: "children",
        label: "name",
      },
      treedata: [],
      colorList: {
        province: "success",
        city: "",
        2: "info",
        3: "warning",
        4: "danger",
      },
      levelList: {
        province: "省级",
        city: "市级",
        2: "区县",
        3: "街道",
        4: "社区",
      },
      dataInfo: {},
    }
  },
  created() {
    this.dataTree = []
    console.log("我的机构位置", this.$store.state.info)
    this.treeStyle = this.$store.state.info.roleIds[0]
  },
  mounted() {},
  methods: {
    showDialogForm(item, title) {
      this.title = title
      this.dataInfo = item
      if (title === "新增下级") {
        this.formData.level = item.level === "city" ? 2 : item.level + 1
        this.formData.addName = ""
        this.formData.parentId = item.adcode
      }

      this.dialogVisible = true
    },

    // 保存
    handleSubmit(formName) {
      this.$refs.formDataRef.validate((valid) => {
        if (valid) {
          if (this.title === "编辑") {
            this.$http
              .request({
                url: "/ypt/admin/standardAddress/info/save",
                method: "POST",
                data: this.formData,
              })
              .then((res) => {
                console.log(res.code, "aaa")
                if (res.code == 200) {
                  this.$message.success(res.message)
                  this.mapshow = false
                  this.dataTree = []
                  this.dialogVisibleClone()
                  this.refreshNode()
                } else {
                  this.$message.error(res.message)
                }
              })
          } else {
            console.log(this.formData, "xxx")
            this.$http
              .request({
                url: "ypt/admin/addressYpe/info/save",
                method: "POST",
                data: this.formData,
              })
              .then((res) => {
                if (res.code == 200) {
                  this.$message.success(res.message)
                  this.mapshow = false
                  this.dataTree = []
                  this.dialogVisibleClone()
                  this.refreshNode()
                } else {
                  this.$message.error(res.message)
                }
              })
          }
        }
      })
    },
    refreshNode(type) {
      const tree = this.$refs.treeRef
      console.log(this.dataInfo, "ssssssssssssss")
      const node = tree.getNode(
        type === "del" ? this.dataInfo.parentId : this.dataInfo.adcode
      )
      if (node) {
        node.loaded = false // 将节点设置为未加载状态
        tree.store.load(node, () => {
          console.log("节点已刷新")
        })
      }
    },
    dialogVisibleClone() {
      this.dialogVisible = false
      this.formData.parentId = undefined
      this.$refs.formDataRef.resetFields()
    },
    // 取消
    cancleForm(formName) {
      // this.formData={}
      this.$refs[formName].resetFields()
      this.mapshow = false
    },
    async loadNode2(node, resolve) {
      let data = []
      if (node.level < 2) {
        const getDistrict = await this.getDistrict(
          node.data ? node.data.adcode : null
        )

        data = getDistrict.districtList
        // let roleIds = this.$store.state.info.roleIds.indexOf(1) == -1 ? 0 : 1
        // if (roleIds == 1) {

        // } else {
        // await this.getOrg()
        // }
      } else if (node.level < 5) {
        data = await this.addressYpeList(node.data)
      }
      resolve(data)

      // 强制更新节点数据
      this.$nextTick(() => {
        this.$refs.treeRef.updateKeyChildren(node.data.adcode, data)
      })
    },
    async addressYpeList(data) {
      const { content } = await this.$http.request({
        url: "/ypt/admin/addressYpe/info/findList",
        method: "POST",
        data: {
          parentId: data.adcode,
          pageNo: 1,
          pageSize: -1,
        },
      })
      return (
        content.list.map((item) => {
          item.name = item.addName
          item.adcode = item.addCode
          return item
        }) || []
      )
    },
    //树形列表
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    //树形结果显示内容自定义
    renderContent(h, { node, data, store }) {
      return (
        <span class="tree-span">
          <span class="tree-span-label">
            <el-tag type={this.colorList[data.level]} size="small">
              {this.levelList[data.level]}
            </el-tag>
            &nbsp;&nbsp;
            {node.label}
          </span>

          <span class="tree-span-button">
            <div>
              {data.level === "city" || (data.level > 1 && data.level < 4) ? (
                <el-button
                  size="mini"
                  type="primary"
                  on-click={() => this.showDialogForm(data, "新增下级")}
                >
                  新增下级
                </el-button>
              ) : (
                ""
              )}

              {data.level > 1 && data.level < 5 ? (
                <el-button
                  size="mini"
                  type="danger"
                  on-click={() => this.deletDataFuns(data)}
                >
                  删除
                </el-button>
              ) : (
                ""
              )}
            </div>
          </span>
        </span>
      )
    },
    // 获取机构
    getOrg() {
      this.$http
        .request({
          url: "/rbac/admin/org/info/findOrgById",
          method: "POST",
          data: { id: this.$store.state.info.orgId },
        })
        .then((res) => {
          if (res.code == 200) {
            this.normalInfo = res.content
          }
        })
    },

    // 成功返回
    mapSuccess(info) {
      this.formData.areaDivision = info
      console.log(info, "地图信息")
    },
    // 地图显示
    location() {
      if (this.formData.shengId) {
        this.mapshow = !this.mapshow
        // this.joinAddress()
        // this.mapInit()
        console.log(this.formData, "提交数据")
      } else {
        this.$message.warning("请先选择地址")
      }
    },
    //获取社区组织树形数据
    async handleNodeClick(data, node, resolve) {
      console.log(node, "555")
      let lngLat = node.data.center
      if (lngLat) {
        this.formData.latitude = lngLat.lat
        this.formData.longitude = lngLat.lng
      }

      if (node.level == 1) {
        this.formData.shengId = node.data.adcode
        this.formData.shiId = ""
        this.formData.quId = ""
        this.formData.jiedaoId = ""
        this.formData.parentId = ""
        this.formData.address = ""
        this.formData.areaDivision = ""
      } else if (node.level == 2) {
        this.formData.shiId = node.data.adcode
        this.formData.quId = ""
        this.formData.jiedaoId = ""
        this.formData.parentId = ""
        this.formData.address = ""
        this.formData.areaDivision = ""
      } else if (node.level == 3) {
        console.log(node.data, "node.data")
        this.formData.quId = node.data.adcode
        this.formData.parentId = ""
        this.formData.jiedaoId = ""
        this.formData.address = ""
        this.formData.areaDivision = ""
      } else if (node.level == 4) {
        console.log(node.data, "node.data")
        this.formData.jiedaoId = node.data.addCode
        this.formData.parentId = node.data.addCode
        this.formData.address = ""
        this.formData.areaDivision = ""
        console.log(this.streetList, "街道列表")
      } else if (node.level == 5) {
        console.log(data, "街道信息")
        this.mapshow = false
        if (data.latitude && data.longitude) {
          this.formData.latitude = data.latitude
          this.formData.longitude = data.longitude
        }
        this.formData.id = data.id
        this.formData.address = data.address
        this.formData.areaDivision = data.areaDivision
        // this.$forceUpdate()
      }
    },
    async loadNode(node, resolve) {
      let data2 = []
      let data1 =
        node.level === 4 || node.level === 5
          ? []
          : await this.getDistrict(node.data.adcode)

      if (this.treeStyle == 1) {
        if (node.level == 1) {
          data2 = data1.districtList.map((item) => {
            item.children = []
            return item
          })
          this.cityList = data2
          resolve(data2)
        } else if (node.level == 2) {
          data2 = data1.districtList.map((item, index) => {
            item.children = []
            item.adcode = item.adcode
            return item
          })
          this.areaList = data2
          console.log(this.areaList, "区")
          resolve(data2)
        } else if (node.level == 3) {
          // data2 = data1.districtList.map((item, index) => {
          //     item.children = []
          //     item.adcode = item.adcode + index
          //     return item
          // })
          // this.streetList = data2
          // console.log(this.streetList, "街道")
          // resolve(data2)
          this.$http
            .request({
              url: "/ypt/admin/addressYpe/info/findList",
              method: "POST",
              data: {
                parentId: node.key,
                pageNo: 1,
                pageSize: -1,
              },
            })
            .then((res) => {
              if (res.code == 200) {
                if (!res.content) {
                  resolve([])
                  return
                }
                data2 = res.content.list.map((item) => {
                  item.children = []
                  item.addName = item.addName
                  item.name = item.addName
                  item.addCode = item.addCode
                  // item.addCode=item.addCode
                  return item
                })
                this.streetList = data2
                console.log(this.streetList, "jiedao")
                resolve(data2)
              } else {
                resolve([])
              }
            })
        } else if (node.level == 4) {
          console.log(node)
          this.$http
            .request({
              url: "/ypt/admin/standardAddress/info/StandardAddressTree",
              method: "POST",
              data: {
                jiedaoId: node.data.addCode,
              },
            })
            .then((res) => {
              if (res.code == 200) {
                if (!res.content) {
                  resolve([])
                  return
                }
                data2 = res.content.map((item) => {
                  item.children = []
                  item.name = item.address
                  item.adcode = item.address
                  return item
                })

                resolve(data2)
              } else {
                resolve([])
              }
            })
        } else if (node.level == 5) {
          resolve([])
        } else {
          data2 = data1.districtList.map((item) => {
            item.children = []
            return item
          })
          console.log(data2, "0")
          resolve(data2)
        }
      } else {
        if (node.level == 0) {
          if (this.normalInfo.provinceId) {
            let dataProvice = []
            data1.districtList.forEach((item, index) => {
              if (item.adcode == this.normalInfo.provinceId) {
                item.children = []
                dataProvice.push(item)
              }
            })
            this.provinceList = dataProvice

            resolve(dataProvice)
          } else {
            resolve([])
          }
        } else if (node.level == 1) {
          if (this.normalInfo.provinceId && this.normalInfo.cityId) {
            let dataCity = []
            data1.districtList.forEach((item, index) => {
              if (item.adcode == this.normalInfo.cityId) {
                item.children = []
                dataCity.push(item)
              }
              // return dataCity
            })
            this.cityList = dataCity
            console.log("城市", this.cityList)
            console.log("省份", this.provinceList)
            resolve(dataCity)
          } else {
            if (this.normalInfo.orgLevel == 1 && this.normalInfo.provinceId) {
              let dataCity = []
              data1.districtList.forEach((item, index) => {
                item.children = []
                dataCity.push(item)
              })
              this.cityList = dataCity
              resolve(dataCity)
            } else {
              resolve([])
            }
          }
        } else if (node.level == 2) {
          if (
            this.normalInfo.provinceId &&
            this.normalInfo.cityId &&
            this.normalInfo.areaId
          ) {
            let dataArea = []
            data1.districtList.forEach((item, index) => {
              if (item.adcode == this.normalInfo.areaId) {
                item.children = []
                dataArea.push(item)
              }
            })
            this.areaList = dataArea
            resolve(dataArea)
          } else {
            if (
              (this.normalInfo.provinceId && this.normalInfo.orgLevel == 2) ||
              (this.normalInfo.provinceId && this.normalInfo.orgLevel == 1)
            ) {
              let dataArea = []
              data1.districtList.forEach((item, index) => {
                item.children = []
                dataArea.push(item)
              })
              this.areaList = dataArea
              resolve(dataArea)
            } else {
              resolve([])
            }
          }
        } else if (node.level == 3) {
          if (
            this.normalInfo.provinceId &&
            this.normalInfo.cityId &&
            this.normalInfo.areaId &&
            this.normalInfo.streetId
          ) {
            // let dataStreet = []
            // data1.districtList.map((item, index) => {
            //     console.log(item.adcode, this.normalInfo.streetId)
            //     if (
            //         item.adcode + index ==
            //         this.normalInfo.streetId
            //     ) {
            //         item.children = []
            //         item.adcode = item.adcode + index
            //         dataStreet.push(item)
            //     }
            // })
            // this.streetList = dataStreet
            // console.log(this.streetList,'this.streetList')
            // resolve(dataStreet)
            this.$http
              .request({
                url: "/ypt/admin/addressYpe/info/findList",
                method: "POST",
                data: {
                  parentId: node.key,
                  pageNo: 1,
                  pageSize: -1,
                },
              })
              .then((res) => {
                if (res.code == 200) {
                  if (!res.content) {
                    resolve([])
                    return
                  }
                  console.log(res.content.list, this.normalInfo.streetId)
                  data2 = res.content.list.map((item) => {
                    if (item.addCode == this.normalInfo.streetId) {
                      item.children = []
                      item.addName = item.addName
                      item.name = item.addName
                      item.addCode = item.addCode
                      // item.addCode=item.addCode
                    } else {
                      item.name = item.addName
                    }
                    return item
                  })
                  this.streetList = data2
                  console.log(this.streetList, "jiedao")
                  resolve(data2)
                }
              })
          } else {
            if (
              (this.normalInfo.provinceId && this.normalInfo.orgLevel == 2) ||
              (this.normalInfo.provinceId && this.normalInfo.orgLevel == 1) ||
              (this.normalInfo.provinceId && this.normalInfo.orgLevel == 3)
            ) {
              this.$http
                .request({
                  url: "/ypt/admin/addressYpe/info/findList",
                  method: "POST",
                  data: {
                    parentId: node.key,
                    pageNo: 1,
                    pageSize: -1,
                  },
                })
                .then((res) => {
                  if (res.code == 200) {
                    if (!res.content) {
                      resolve([])
                      return
                    }
                    data2 = res.content.list.map((item) => {
                      item.children = []
                      item.addName = item.addName
                      item.name = item.addName
                      item.addCode = item.addCode
                      return item
                    })
                    this.streetList = data2
                    console.log(this.streetList, "jiedao11")
                    resolve(data2)
                  }
                })
            } else {
              resolve([])
            }
          }
        } else if (node.level == 4) {
          this.$http
            .request({
              url: "/ypt/admin/standardAddress/info/StandardAddressTree",
              method: "POST",
              data: {
                jiedaoId: node.data.addCode,
              },
            })
            .then((res) => {
              if (res.code == 200) {
                if (!res.content) {
                  resolve([])
                  return
                }
                data2 = res.content.map((item) => {
                  item.children = []
                  item.name = item.address
                  item.adcode = item.address
                  return item
                })

                resolve(data2)
              } else {
                resolve([])
              }
            })
        } else if (node.level == 5) {
          resolve([])
        }
      }
    },
    //获取省级
    async getProvince() {
      this.provinceList = []
      this.cityList = []
      this.areaList = []
      this.streetList = []
      let province = await this.getDistrict()

      this.provinceList = province.districtList
      this.treedata = this.provinceList.map((item) => {
        item.children = []
        return item
      })
      return this.provinceList
    },

    // 添加树
    async addDataFun(parmar, node) {
      let self = this
      this.formData = {}
      let formData = {}
      this.mapshow = false
      if (parmar.communityType == 0) {
        formData.communityName = parmar.shi
        formData.communityType = 1
      } else if (parmar.communityType == 1) {
        formData.communityName = parmar.qu
        formData.communityType = 2
      } else if (parmar.communityType == 2) {
        formData.communityName = parmar.jiedao
        formData.communityType = 3
      } else {
        formData.communityName = parmar.shequ
        formData.communityType = 4
      }
      formData.parentId = parmar.id
      formData.address = parmar.address
      formData.shengId = parmar.shengId
      formData.sheng = parmar.sheng
      formData.quId = parmar.quId
      formData.qu = parmar.qu
      formData.jiedaoId = parmar.jiedaoId
      formData.jiedao = parmar.jiedao
      formData.shiId = parmar.shiId
      formData.shi = parmar.shi
      formData.latitude = parmar.latitude
      formData.longitude = parmar.longitude
      formData.areaDivision = parmar.areaDivision
      this.formData = Object.assign({}, formData)
    },
    // 获取树
    //获取地址
    getDistricts(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    //删除树
    deletDataFuns(row) {
      this.dataInfo = row
      let data = { id: row.id }
      this.$confirm("确认永久删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .request({
            url: "ypt/admin/addressYpe/info/deleteById",
            method: "POST",
            data,
          })
          .then((res) => {
            if (res.code === 200) {
              this.$message.success("删除成功")
              this.refreshNode("del")
            }
          })
      })
    },
    //获取地址
    getDistrict(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        console.log(district)
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            console.log(bounds, "是什么玩意儿")
            self.polygon = null
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },

    // 成功返回
    onSuccess(info) {
      this.formData.areaDivision = info
      console.log(info, "地图信息")
    },
    //  省级地址选择发生改变
    async handleProvince(val) {
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.formData.shi = ""
      this.formData.qu = ""
      this.formData.jiedao = ""
      let city = await this.getDistrict(val)

      this.cityList = city.districtList
    },
    //市级地址发生改变
    async handleCity(val) {
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.formData.qu = ""
      this.formData.jiedao = ""
      let area = await this.getDistrict(val)
      console.log(area.districtList, "111")
      this.areaList = area.districtList
    },
    //县区级地址发生改变
    async handleArea(val) {
      this.streetList = []
      this.communityList = []
      this.formData.originalStreetId = ""
      this.formData.originalCommunityId = ""
      let street = await this.getDistrict(val)
      this.streetList = street.districtList
    },
    //街道地址发生变化
    streetChange(val) {
      this.streetList.forEach((item) => {
        if (item.adcode == val) {
          this.formData.latitude = item.center.lat
          this.formData.longitude = item.center.lng
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.publicMain {
  display: flex;
  justify-content: space-between;
  width: 100%;

  .member-title {
    height: 30px;
    line-height: 30px;
  }

  /deep/ ::-webkit-scrollbar {
    display: block;
  }

  .el-form-item {
    margin-bottom: 25px !important;
  }

  .party-icon {
    display: inline-block;
    width: 16px;
    height: 15px;
    background-image: url("./assets/img/icon_011.png");
  }

  // 左边树状列表卡片
  .card-l {
    width: 260px !important;
    height: 100%;
    overflow-x: auto;
    overflow-y: auto;
    border: none;

    .cardtree {
      overflow-x: auto;
      width: 150%;

      .el-tree-node > .el-tree-node__children {
        overflow: auto;
        background-color: transparent;
      }

      /deep/ ::-webkit-scrollbar {
        display: block;
      }
    }
  }

  // 右边卡片
  .card-rb {
    width: calc(100% - 280px);
    height: 100%;
    overflow-y: auto;
    border: none;

    .card-4 {
      border: none;
      height: 100%;

      .demo-formData {
        .formData_box {
          display: flex;
          justify-content: space-between;
          width: 100%;
          padding: 20px 0;

          .formData_item {
            width: 48%;

            .rulelable {
              width: 100%;
              height: 35px;
            }

            .ruleinput {
              width: 100%;
              display: flex;
              justify-content: space-between;

              .rulespan2 {
                float: left;
                width: 49%;

                .rulespan2_input {
                  width: 100%;
                }
              }
            }
          }

          .ruleradio {
            height: 75px;
            line-height: 75px;
          }
        }

        .formData_bottom {
          width: 100%;
          text-align: right;
          margin-top: 40px;
        }
      }
    }
  }

  .addressselect {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;

    .addressselect_item {
      width: 24%;
    }
  }

  .address_xx {
    width: 100%;
    height: 320px;
    display: flex;
    justify-content: space-between;

    .add_list {
      width: 24%;
      height: 300px;
      border: 1px solid #c0c6d9;
      border-radius: 5px;
      overflow-y: auto;
    }

    .add_map {
      width: 74%;
      height: 300px;
      border: 1px solid #c0c6d9;
    }
  }

  .custom-tree-node {
    position: relative;

    .el-icon-s-icon {
      content: url(./assets/img/icon_011.png);
      width: 15px;
      height: 15px;
      float: left;
      margin-top: 3px;
    }

    .tree-node-span {
      margin-left: 10px;
    }

    .el-icon-s-add {
      content: url(./assets/img/metro_05.png);
      width: 15px;
      margin-left: 10px;
    }

    .el-icon-s-add:hover {
      content: url(./assets/img/metro_03.png);
    }

    .el-icon-delete {
      content: url(./assets/img/metro_14.png);
      width: 15px;
      margin-left: 10px;
    }

    .el-icon-delete:hover {
      content: url(./assets/img/metro_13.png);
      // width: 12px;
      // height: 12px;
      // margin-left: 10px;
    }
  }

  .ZUZHIimg {
    position: relative;

    .threestyleimg {
      display: flex;
      flex-wrap: wrap;

      .threestyleimgtu {
        width: 100%;
        height: 70%;
        // background-color: red;
        display: flex;
        // justify-content: center;
        // align-items: center;
      }

      .threestyleimgbtnzzxz {
        input {
          position: absolute;
          top: 0;
          left: 0;
          width: 463px;
          height: 200px;
          opacity: 0;
          cursor: pointer;
        }
      }

      .el-icon-s-add {
        content: url(./assets/img/metro_05.png);
        width: 15px;
        margin-left: 10px;
      }

      .el-icon-s-add:hover {
        content: url(./assets/img/metro_03.png);
      }

      .el-icon-delete {
        content: url(./assets/img/metro_14.png);
        width: 15px;
        margin-left: 10px;
      }

      .el-icon-delete:hover {
        content: url(./assets/img/metro_13.png);
        // width: 12px;
        // height: 12px;
        // margin-left: 10px;
      }
    }

    .ZUZHIimg {
      position: relative;

      .threestyleimg {
        display: flex;
        flex-wrap: wrap;

        .threestyleimgtu {
          width: 100%;
          height: 70%;
          // background-color: red;
          display: flex;
          // justify-content: center;
          // align-items: center;
        }

        .threestyleimgbtnzzxz {
          input {
            position: absolute;
            top: 0;
            left: 0;
            width: 463px;
            height: 200px;
            opacity: 0;
            cursor: pointer;
          }
        }
      }
    }

    .el-form-item {
      margin-bottom: 0px;
    }
  }
}

.elder_manage_title {
  position: relative;
  width: 100%;
  margin-bottom: 15px;

  &::after {
    position: absolute;
    left: 120px;
    right: 0;
    display: block;
    content: "";
    border-bottom: 1px solid #e4e7ed;
  }

  .title {
    box-sizing: border-box;
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #409eff;
    font-size: 14px;
    border: 1px solid #e4e7ed;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
    background: #ffffff;
  }
}

.footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 15px;
}

#organizationMap {
  width: 100%;
  height: 470px;
}

// 深度穿透样式
/deep/ .el-tree-node__content {
  border: 1px solid #ebeef5 !important;
  border-top: 0px;
  height: 40px;
  line-height: 40px;
}

/deep/ .tree-span {
  font-size: 13px;

  .tree-span-code {
    position: absolute;
    right: 570px;
    width: 120px;
    text-align: center;
  }

  .tree-span-status {
    position: absolute;
    right: 470px;
    width: 100px;
    text-align: center;
  }

  .tree-span-time {
    position: absolute;
    right: 330px;
    width: 140px;
    text-align: center;
  }

  .tree-span-sort {
    position: absolute;
    right: 250px;
    width: 80px;
    text-align: center;
  }

  .tree-span-button {
    position: absolute;
    right: 10px;
    width: 240px;
    text-align: center;
  }
}

.posaddress {
  position: relative;

  i {
    position: absolute;
    right: 20px;
    color: #0000ff;
    font-size: 28px;
    top: 7px;
  }
}

.addressFrom {
  display: flex;
  margin-left: 73px;
  height: 30px;

  .addressTitle {
    text-align: right;
    vertical-align: middle;
    font-size: 14px;
    color: #606266;
    line-height: 30px;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;

    span {
      color: #f56c6c;
      margin-right: 4px;
    }
  }

  .addressContent {
    flex: 1;

    .addressBox {
      display: flex;

      .addressItem {
        flex: 1;

        /deep/ .el-form-item__content {
          margin-left: 0px !important;
        }

        /deep/ .el-select {
          width: 100% !important;
        }
      }
    }

    /deep/ .el-form-item__content {
      margin-left: 0px !important;
    }
  }
}

/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    // text-align: right;
  }
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>
